// extracted by mini-css-extract-plugin
export default {"hosted":"style_hosted__0T2Zo","content":"style_content__nOIXU"};